/* ============================================================
   Wav Monopoly — Bundle Builder (cart-backed)
   The bundle "deal" panel is a live view of the CART:
   - Add  -> POST /cart/add.js (tagged with hidden property _wm_bundle)
   - Remove -> POST /cart/change.js (line -> 0)
   - On every page load it rebuilds from /cart.js, so the bundle
     persists across pages (home -> back, or a preset product page).
   Any section that adds presets with the same _wm_bundle property
   and reads the cart the same way stays in sync (e.g. the PDP bundle).
   ============================================================ */
(function () {
  'use strict';

  var CART_PROP = '_wm_bundle';                 // hidden line-item property tagging bundle items
  var SECTIONS = ['cart-icon-bubble', 'cart-drawer'];

  function init(root) {
    if (!root || root.dataset.wmBundleReady === 'true') return;
    root.dataset.wmBundleReady = 'true';

    // ---- config ----
    var cfg = {};
    var cfgEl = root.querySelector('[data-bundle-config]');
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { cfg = {}; }
    var MONEY_FORMAT = cfg.moneyFormat || '${{amount}}';
    var CHECKOUT_REDIRECT = cfg.checkoutRedirect || '/checkout';
    var TIERS = (cfg.tiers || []).slice().sort(function (a, b) { return a.qty - b.qty; });
    var MAX_SLOTS = cfg.maxSlots || 3;
    var maxTierQty = TIERS.length ? TIERS[TIERS.length - 1].qty : 1;

    // ---- elements ----
    var grid = root.querySelector('[data-bundle-grid]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-card]'));
    var emptyEl = root.querySelector('[data-bundle-empty]');
    var searchInput = root.querySelector('[data-bundle-search]');
    var searchClear = root.querySelector('[data-bundle-search-clear]');
    var sortSelect = root.querySelector('[data-bundle-sort]');
    var dawSelect = root.querySelector('[data-bundle-daw]');
    var slotsEl = root.querySelector('[data-bundle-slots]');
    var totalEl = root.querySelector('[data-bundle-total]');
    var totalWasEl = root.querySelector('[data-bundle-total-was]');
    var saveEl = root.querySelector('[data-bundle-save]');
    var saveAmtEl = root.querySelector('[data-bundle-save-amt]');
    var checkoutBtn = root.querySelector('[data-bundle-checkout]');
    var noteEl = root.querySelector('[data-bundle-note]');
    var errorEl = root.querySelector('[data-bundle-error]');
    var stopEls = Array.prototype.slice.call(root.querySelectorAll('[data-tier-qty]'));

    // ---- pop-down bar: once the deal panel's checkout button scrolls off-screen, the
    //      total + checkout follow the shopper (same pattern as the preset PDP's bar) ----
    var bar = document.createElement('div');
    bar.className = 'wm-purchase-bar wm-bundle-bar';
    bar.hidden = true;
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Your bundle');
    var barInfo = document.createElement('div');
    barInfo.className = 'wm-purchase-bar__info';
    var barTitle = document.createElement('strong');
    var barDetail = document.createElement('span');
    barDetail.className = 'wm-bundle-bar__save';
    var barNudge = document.createElement('span');
    barNudge.className = 'wm-bundle-bar__nudge';
    barInfo.append(barTitle, barDetail, barNudge);
    var barTrack = document.createElement('div');   // thin tier-progress strip along the bar's bottom edge
    barTrack.className = 'wm-bundle-bar__track';
    barTrack.setAttribute('aria-hidden', 'true');
    var barAction = document.createElement('button');
    barAction.type = 'button';
    barAction.className = 'wm-purchase-bar__action wm-glow-button';
    var barError = document.createElement('span');
    barError.className = 'wm-purchase-bar__error';
    barError.setAttribute('role', 'status');
    bar.append(barInfo, barAction, barError, barTrack);
    root.appendChild(bar);
    var siteHeader = document.querySelector('.section-header');
    var layoutEl = root.querySelector('.wm-bundle__layout');

    // ---- state: productId -> {variantId, price, title, image, key} (mirror of the cart) ----
    var bundle = {};
    var busy = false;
    function bundleItems() { return Object.keys(bundle).map(function (k) { return bundle[k]; }); }

    /* ----------------------------- money ----------------------------- */
    function formatMoney(cents) {
      function withDelims(num, precision, thousands, decimal) {
        precision = isNaN(precision) ? 2 : precision;
        thousands = thousands == null ? ',' : thousands;
        decimal = decimal == null ? '.' : decimal;
        if (num == null || isNaN(num)) return '0';
        var value = (num / 100.0).toFixed(precision);
        var parts = value.split('.');
        var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var cents2 = parts[1] ? decimal + parts[1] : '';
        return dollars + cents2;
      }
      var out;
      var match = MONEY_FORMAT.match(/\{\{\s*(\w+)\s*\}\}/);
      var token = match ? match[1] : 'amount';
      switch (token) {
        case 'amount': out = withDelims(cents, 2); break;
        case 'amount_no_decimals': out = withDelims(cents, 0); break;
        case 'amount_with_comma_separator': out = withDelims(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': out = withDelims(cents, 0, '.', ','); break;
        case 'amount_with_space_separator': out = withDelims(cents, 2, ' ', ','); break;
        case 'amount_no_decimals_with_space_separator': out = withDelims(cents, 0, ' ', ''); break;
        case 'amount_with_apostrophe_separator': out = withDelims(cents, 2, "'", '.'); break;
        default: out = withDelims(cents, 2);
      }
      return MONEY_FORMAT.replace(/\{\{\s*\w+\s*\}\}/, out);
    }

    /* ----------------------------- pricing ----------------------------- */
    function tierForCount(count) {
      var applied = null;
      for (var i = 0; i < TIERS.length; i++) { if (count >= TIERS[i].qty) applied = TIERS[i]; }
      return applied;
    }
    function compute() {
      var items = bundleItems();
      var count = items.length;
      var subtotal = items.reduce(function (s, i) { return s + i.price; }, 0);
      var tier = tierForCount(count);
      var pct = tier ? tier.pct : 0;
      var total = Math.round(subtotal * (100 - pct) / 100);
      return { count: count, subtotal: subtotal, total: total, savings: subtotal - total, pct: pct, tier: tier };
    }

    /* ----------------------------- card helpers ----------------------------- */
    function cardById(id) {
      for (var i = 0; i < cards.length; i++) { if (cards[i].dataset.productId === String(id)) return cards[i]; }
      return null;
    }
    function variantControl(card) { return card.querySelector('[data-bundle-variant]'); }
    function readVariant(card) {
      var ctrl = variantControl(card);
      if (!ctrl) return null;
      var variantId, price;
      if (ctrl.tagName === 'SELECT') {
        var opt = ctrl.options[ctrl.selectedIndex];
        if (!opt) return null;
        variantId = opt.value; price = parseInt(opt.getAttribute('data-price'), 10);
      } else {
        variantId = ctrl.value; price = parseInt(ctrl.getAttribute('data-price'), 10);
      }
      if (isNaN(price)) price = parseInt(card.dataset.price, 10) || 0;
      var imgEl = card.querySelector('.wm-bcard__img');
      return {
        productId: card.dataset.productId, variantId: variantId, price: price,
        title: card.dataset.title || '', image: imgEl ? imgEl.currentSrc || imgEl.src : ''
      };
    }
    // Display-only: keep each card's shown price in step with its selected DAW
    // (the WMA option is half off), and toggle the "with WMA plugin" cue.
    function repriceCard(card) {
      var ctrl = variantControl(card);
      if (!ctrl || ctrl.tagName !== 'SELECT') return;
      if (ctrl._wmSyncPicker) ctrl._wmSyncPicker();
      var opt = ctrl.options[ctrl.selectedIndex];
      if (!opt) return;
      var nowEl = card.querySelector('[data-bcard-price-now]');
      var wasEl = card.querySelector('[data-bcard-price-was]');
      var hintEl = card.querySelector('[data-bcard-wma-hint]');
      var priceDisplay = opt.getAttribute('data-price-display');
      var compareDisplay = opt.getAttribute('data-compare-display');
      var price = parseInt(opt.getAttribute('data-price'), 10);
      var compare = parseInt(opt.getAttribute('data-compare'), 10) || 0;
      var isWma = opt.getAttribute('data-wma') === 'true';
      var onSale = !isNaN(price) && compare > price;
      if (nowEl && priceDisplay) nowEl.textContent = priceDisplay;
      if (wasEl) { wasEl.hidden = !onSale; if (onSale && compareDisplay) wasEl.textContent = compareDisplay; }
      if (hintEl) hintEl.hidden = !isWma;
    }
    function syncCard(card) {
      var added = !!bundle[card.dataset.productId];
      card.classList.toggle('is-added', added);
      var btn = card.querySelector('[data-bundle-add]');
      if (btn) {
        btn.setAttribute('aria-pressed', added ? 'true' : 'false');
        var label = btn.querySelector('.wm-bcard__add-label');
        if (label) label.textContent = added ? 'Added' : 'Add';
      }
    }

    /* ----------------------------- cart sync ----------------------------- */
    function getCart() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    }
    function cartFetch(url, body) {
      body.sections = SECTIONS;
      body.sections_url = window.location.pathname;
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, status: res.status, data: data }; });
      });
    }
    function applySection(sections, id, selector) {
      if (!sections || typeof sections[id] !== 'string') return;
      var target = document.querySelector(selector);
      if (!target) return;
      try {
        var doc = new DOMParser().parseFromString(sections[id], 'text/html');
        var src = doc.querySelector(selector) || doc.getElementById(id);
        if (src) target.innerHTML = src.innerHTML;
      } catch (e) { /* noop */ }
    }
    function updateCartUI(data) {
      if (!data) return;
      applySection(data.sections, 'cart-icon-bubble', '#cart-icon-bubble');
      applySection(data.sections, 'cart-drawer', '#CartDrawer');
      document.dispatchEvent(new CustomEvent('wm:cart:update', { detail: data }));
    }
    function syncFromCart() {
      return getCart().then(function (cart) {
        bundle = {};
        (cart.items || []).forEach(function (it) {
          if (it.properties && it.properties[CART_PROP]) {
            bundle[String(it.product_id)] = {
              productId: String(it.product_id),
              variantId: it.variant_id,
              price: it.original_price != null ? it.original_price : it.price,
              title: it.product_title || it.title || '',
              image: it.image || (it.featured_image && it.featured_image.url) || '',
              key: it.key
            };
          }
        });
        cards.forEach(syncCard);
        render();
      }).catch(function () { /* leave current state */ });
    }

    /* ----------------------------- mutate (cart) ----------------------------- */
    function addItem(card) {
      var data = readVariant(card);
      if (!data || !data.variantId) return Promise.resolve();
      var props = {}; props[CART_PROP] = '1';
      return cartFetch('/cart/add.js', { items: [{ id: data.variantId, quantity: 1, properties: props }] })
        .then(function (resp) {
          if (!resp.ok) { showError((resp.data && resp.data.description) || 'Could not add to cart.'); return; }
          updateCartUI(resp.data);
          return syncFromCart();
        });
    }
    function removeItem(productId) {
      var item = bundle[productId];
      if (!item || !item.key) return Promise.resolve();
      return cartFetch('/cart/change.js', { id: item.key, quantity: 0 })
        .then(function (resp) {
          if (resp.ok) updateCartUI(resp.data);
          return syncFromCart();
        });
    }
    function guarded(fn) {
      if (busy) return;
      busy = true; setBusy(true);
      Promise.resolve(fn()).catch(function () { showError('Something went wrong. Please try again.'); })
        .then(function () { busy = false; setBusy(false); });
    }
    function toggleItem(card) {
      guarded(function () {
        return bundle[card.dataset.productId] ? removeItem(card.dataset.productId) : addItem(card);
      });
    }
    function setBusy(on) {
      root.classList.toggle('wm-bundle--busy', on);
      if (checkoutBtn) checkoutBtn.classList.toggle('is-loading', on);
      barAction.disabled = on || !checkoutBtn || checkoutBtn.disabled;
    }

    /* ----------------------------- render ----------------------------- */
    function renderSlots(items) {
      if (!slotsEl) return;
      var n = Math.max(MAX_SLOTS, items.length);
      var html = '';
      for (var i = 0; i < n; i++) {
        if (i < items.length) {
          var it = items[i];
          var img = it.image
            ? '<img src="' + escapeAttr(it.image) + '" alt="' + escapeAttr(it.title) + '">'
            : '<span class="wm-bdeal__slot-ph">' + escapeHtml((it.title || '?').charAt(0)) + '</span>';
          html += '<div class="wm-bdeal__slot wm-bdeal__slot--filled" title="' + escapeAttr(it.title) + '">'
            + img + '<button type="button" class="wm-bdeal__slot-remove" data-bundle-remove="' + escapeAttr(it.productId)
            + '" aria-label="Remove ' + escapeAttr(it.title) + '">&times;</button></div>';
        } else {
          html += '<div class="wm-bdeal__slot"><span class="wm-bdeal__slot-ph">+</span></div>';
        }
      }
      slotsEl.innerHTML = html;
    }
    function renderTiers(count) {
      stopEls.forEach(function (el) {
        var qty = parseInt(el.getAttribute('data-tier-qty'), 10);
        el.classList.toggle('is-active', count >= qty);
      });
      var fillEl = root.querySelector('[data-bundle-track]');
      if (fillEl) {
        var fill = maxTierQty > 1 ? Math.min(Math.max(count - 1, 0) / (maxTierQty - 1), 1) * 100 : (count > 0 ? 100 : 0);
        fillEl.style.setProperty('--fill', fill + '%');
      }
    }
    function nextTier(count) {
      for (var i = 0; i < TIERS.length; i++) { if (TIERS[i].qty > count && TIERS[i].pct > 0) return TIERS[i]; }
      return null;
    }
    function render() {
      var r = compute();
      renderSlots(bundleItems());
      renderTiers(r.count);
      if (totalEl) totalEl.textContent = formatMoney(r.total);
      if (totalWasEl) {
        if (r.savings > 0) { totalWasEl.textContent = formatMoney(r.subtotal); totalWasEl.hidden = false; }
        else totalWasEl.hidden = true;
      }
      if (saveEl) {
        if (r.savings > 0) { saveEl.hidden = false; if (saveAmtEl) saveAmtEl.textContent = formatMoney(r.savings); }
        else saveEl.hidden = true;
      }
      if (checkoutBtn) checkoutBtn.disabled = r.count === 0;
      if (noteEl) {
        if (r.count === 0) noteEl.textContent = 'Add a preset to start your bundle';
        else if (r.pct > 0) noteEl.textContent = 'In your cart • ' + r.pct + '% bundle discount applied';
        else {
          var next = nextTier(r.count);
          noteEl.textContent = next ? 'Add ' + (next.qty - r.count) + ' more to save ' + next.pct + '%' : 'In your cart';
        }
      }
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
      renderBar(r);
    }
    function renderBar(r) {
      r = r || compute();
      barTitle.textContent = r.count + ' preset' + (r.count === 1 ? '' : 's') + ' · ' + formatMoney(r.total);
      // savings so far, then the nudge toward the next tier (or the "best deal" line at the top tier)
      barDetail.textContent = r.savings > 0 ? 'Saving ' + formatMoney(r.savings) + ' (' + r.pct + '% off)' : '';
      barDetail.hidden = !(r.savings > 0);
      var next = nextTier(r.count);
      var more = next ? next.qty - r.count : 0;
      barNudge.textContent = next ? 'Add ' + more + ' more preset' + (more === 1 ? '' : 's') + ' to save ' + next.pct + '%'
                                  : (r.pct > 0 ? 'Best deal unlocked: ' + r.pct + '% off' : '');
      barNudge.classList.toggle('is-maxed', !next && r.pct > 0);
      barNudge.hidden = !barNudge.textContent;
      var fill = Math.min(r.count / Math.max(maxTierQty, 1), 1) * 100;   // no dots here, so 1 of 3 shows a third
      barTrack.style.setProperty('--fill', fill + '%');
      barAction.textContent = checkoutBtn ? checkoutBtn.textContent.trim() : 'Checkout';
      barAction.disabled = busy || !checkoutBtn || checkoutBtn.disabled;
      barError.textContent = errorEl && !errorEl.hidden ? errorEl.textContent : '';
      updateBar();
    }
    function updateBar() {
      if (!checkoutBtn) return;
      var headerBottom = siteHeader ? Math.max(0, siteHeader.getBoundingClientRect().bottom) : 0;
      bar.style.setProperty('--wm-purchase-top', headerBottom + 'px');
      // only while something is in the bundle and the panel's own button is off-screen: scrolled up
      // under the header, or (desktop sticky panel taller than a short window) stuck below the fold
      var btn = checkoutBtn.getBoundingClientRect();
      var onScreen = btn.bottom > headerBottom && btn.top < window.innerHeight;
      var inBuilder = !layoutEl || layoutEl.getBoundingClientRect().top < headerBottom + 40; // not while the hero is still on screen
      bar.hidden = compute().count === 0 || onScreen || !inBuilder;
    }

    /* ----------------------------- filtering / sorting ----------------------------- */
    function applyFilters() {
      var q = (searchInput && searchInput.value || '').trim().toLowerCase();
      var daw = (dawSelect && dawSelect.value) || '';
      var visible = 0;
      cards.forEach(function (card) {
        var title = (card.dataset.title || '').toLowerCase();
        var daws = (card.dataset.daws || '').split(',').map(function (s) { return s.trim(); });
        var show = (!q || title.indexOf(q) !== -1) && (!daw || daws.indexOf(daw) !== -1);
        card.classList.toggle('is-hidden', !show);
        if (show) visible++;
      });
      if (emptyEl) emptyEl.hidden = visible > 0;
      if (searchClear) searchClear.classList.toggle('is-visible', !!q);
    }
    function applySort() {
      if (!sortSelect || !grid) return;
      var mode = sortSelect.value;
      var arr = cards.slice();
      arr.sort(function (a, b) {
        if (mode === 'price-asc') return (+a.dataset.price) - (+b.dataset.price);
        if (mode === 'price-desc') return (+b.dataset.price) - (+a.dataset.price);
        if (mode === 'title-asc') return (a.dataset.title || '').localeCompare(b.dataset.title || '');
        return (+a.dataset.position) - (+b.dataset.position);
      });
      var frag = document.createDocumentFragment();
      arr.forEach(function (c) { frag.appendChild(c); });
      grid.appendChild(frag);
    }
    function buildDawOptions() {
      if (!dawSelect) return;
      var set = {};
      cards.forEach(function (card) {
        (card.dataset.daws || '').split(',').forEach(function (d) { d = d.trim(); if (d) set[d] = true; });
      });
      var names = Object.keys(set).sort();
      names.forEach(function (name) {
        var opt = document.createElement('option');
        opt.value = name;
        opt.textContent = name.replace(/\b\w/g, function (c) { return c.toUpperCase(); });
        dawSelect.appendChild(opt);
      });
      if (names.length === 0) { var f = dawSelect.closest('.wm-bfield'); if (f) f.style.display = 'none'; }
    }

    /* ----------------------------- checkout ----------------------------- */
    function checkout() {
      if (compute().count === 0) return;
      window.location.href = CHECKOUT_REDIRECT;   // items already in the cart
    }
    function showError(msg) {
      if (!errorEl) { return; }
      errorEl.textContent = msg; errorEl.hidden = false;
      barError.textContent = msg;
    }

    /* ----------------------------- escaping ----------------------------- */
    function escapeHtml(s) { return String(s).replace(/[&<>]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]; }); }
    function escapeAttr(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

    /* ----------------------------- events ----------------------------- */
    cards.forEach(function (card) {
      var addBtn = card.querySelector('[data-bundle-add]');
      if (addBtn) addBtn.addEventListener('click', function () { toggleItem(card); });
      var ctrl = variantControl(card);
      if (ctrl && ctrl.tagName === 'SELECT') {
        repriceCard(card);
        ctrl.addEventListener('change', function () {
          repriceCard(card);
          if (bundle[card.dataset.productId]) {
            guarded(function () { return removeItem(card.dataset.productId).then(function () { return addItem(card); }); });
          }
        });
      }
    });
    if (slotsEl) {
      slotsEl.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-bundle-remove]');
        if (btn) { var id = btn.getAttribute('data-bundle-remove'); guarded(function () { return removeItem(id); }); }
      });
    }
    if (searchInput) searchInput.addEventListener('input', applyFilters);
    if (searchClear) searchClear.addEventListener('click', function () { searchInput.value = ''; applyFilters(); searchInput.focus(); });
    if (sortSelect) sortSelect.addEventListener('change', applySort);
    function applyDawSelection() {
      var daw = (dawSelect && dawSelect.value || '').toLowerCase();
      if (daw) cards.forEach(function (card) {
        if (bundle[card.dataset.productId]) return;
        var control = card.querySelector('select[data-bundle-variant]');
        if (!control) return;
        var current = control.options[control.selectedIndex];
        var choices = Array.from(control.options).filter(function (option) {
          return !option.disabled && option.getAttribute('data-daw') === daw;
        });
        var match = choices.find(function (option) {
          return current && option.getAttribute('data-version') === current.getAttribute('data-version');
        }) || choices[0];
        if (match) { control.value = match.value; repriceCard(card); }
      });
      applyFilters();
    }
    if (dawSelect) dawSelect.addEventListener('change', applyDawSelection);
    if (checkoutBtn) checkoutBtn.addEventListener('click', checkout);
    barAction.addEventListener('click', function () { if (!busy) checkout(); });
    window.addEventListener('scroll', updateBar, { passive: true });
    window.addEventListener('resize', updateBar);
    var barHeaderObserver = new ResizeObserver(updateBar);
    if (siteHeader) barHeaderObserver.observe(siteHeader);
    document.addEventListener('shopify:section:unload', function cleanupBar(e) {
      if (!e.target.contains(root)) return;
      window.removeEventListener('scroll', updateBar);
      window.removeEventListener('resize', updateBar);
      barHeaderObserver.disconnect();
      document.removeEventListener('shopify:section:unload', cleanupBar);
    });

    // re-sync if the cart changes elsewhere (e.g. PDP bundle, cart drawer)
    document.addEventListener('wm:cart:update', function (e) { if (!e.__wmInternal) syncFromCart(); });

    // ---- boot ----
    buildDawOptions();
    applySort();
    applyFilters();
    root._wmSync = syncFromCart;
    render();
    syncFromCart();   // rebuild from the cart so the bundle persists across pages
  }

  function boot() { document.querySelectorAll('[data-bundle-root]').forEach(init); }
  // restore from the cart when returning via the back/forward cache
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) document.querySelectorAll('[data-bundle-root]').forEach(function (r) { if (r._wmSync) r._wmSync(); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector ? e.target.querySelector('[data-bundle-root]') : null;
    if (root) init(root);
  });
})();
